import React from "react";
import { Link } from "react-router-dom";
import { BsGlobe } from "react-icons/bs";
import { CiLinkedin } from "react-icons/ci";
import { FiInstagram, FiTwitter } from "react-icons/fi";
import { PiTShirt } from "react-icons/pi";
import { TbHorseToy } from "react-icons/tb";
import { TfiBook } from "react-icons/tfi";
import Logo2 from "../../assets/images/Logo2.png";
import styles from "./Footer.module.scss";

const Footer = () => {
	return (
		<footer className={styles.Footer}>
			<div className={styles.Top}>
				<div className={styles.C1}>
					<img src={Logo2} alt="MINE Kids Logo" title="Logo" width="100%" height="100%" loading="eager" />
				</div>
				<div className={styles.C2}>
					<h3>About us</h3>
					<Link to="/">Home</Link>
					<Link to="/AboutUs">About us</Link>
					<Link to="/OurCurriculum">Our Curriculum</Link>
					<Link to="/privacy-policy">Privacy Policies</Link>
				</div>
				<div className={styles.C3}>
					<h3>More</h3>
					<Link to="/Programme">Pre-school programme</Link>
					<Link to="/Blogs">Blogs</Link>
				</div>
			</div>
			<div className={styles.Bottom}>
				<div className={styles.C1}>
					<h3>Follow Us</h3>
					<span></span>

					<div className={styles.SocialIcons}>
						<a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
							<FiInstagram />
						</a>
						<a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
							<FiTwitter />
						</a>
						<a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
							<CiLinkedin />
						</a>
						<a href="https://minekids.in" target="_blank" rel="noopener noreferrer" aria-label="Website">
							<BsGlobe />
						</a>
					</div>
				</div>
				<div className={styles.C2}>@mineKids.in</div>
				<div className={styles.C3}>
					<h2>near by vendors</h2>
					<div className={styles.Cont}>
						<Link to="/Vendors" className={styles.Wrapper}>
							<div className={styles.round}>
								<PiTShirt />
							</div>
							<p>Uniform</p>
						</Link>
						<Link to="/Vendors" className={styles.Wrapper}>
							<div className={styles.round}>
								<TfiBook />
							</div>
							<p>Books</p>
						</Link>
						<Link to="/Vendors" className={styles.Wrapper}>
							<div className={styles.round}>
								<TbHorseToy />
							</div>
							<p>Toys</p>
						</Link>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
